import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useNavigate } from "react-router-dom";

function Bank_Card_Content() {
  const navigate = useNavigate();
  return (
    <>
      <section className="Bank_Card_Content">
        <section className="Withdraw_bank_info">
          {/* Bank Info */}
          <div className="bank_row" onClick={() => navigate("/bank-account")}>
            <div className="row">
              <div className="col-4">
                <div className="bank_left">
                  <div className="bank_icon">
                    <img
                      src="/assets/images/withdraw_Deposite/Payment_Method_Cards/State_Bank.png"
                      className="bank_img"
                      alt="bank img"
                    />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="bank_right">6832090****6334</div>
              </div>

              <div className="col-2">
                <div className="bank_right">
                  <FontAwesomeIcon icon={faAngleRight} />
                </div>
              </div>
            </div>
          </div>

           
        </section>
      </section>
    </>
  );
}

export default Bank_Card_Content;
